<template>
  <svg x="0px" y="0px" viewBox="0 0 394 203.6" xml:space="preserve">
    <g>
      <g>
        <path
          d="M114,91.8c0-28.5-18.8-36.7-33.1-36.7c-9.7,0-19.2,3.9-27.3,9.9V14H22v6.1v2.3v6.1h16.8v100.9H22v6.1v2.3v6.1h48.5v-6.1
            v-2.3v-6.1h-17V84.6c7.6-9.1,17.6-15,27.3-15c9.5,0,18.4,4.4,18.4,22.2V144h31.7v-6.1v-2.3v-6.1h-17V91.8z"
        />
        <path
          d="M330.5,55.1c-27.8,0-45.4,21.7-45.4,45.4c0,24.7,19.2,45.1,47,45.1c13.1,0,26.2-5.2,36.4-13.6l-4-4.7l-1.5-1.6l-3.9-4.9
            c-8.1,6.6-16.8,10.2-27,10.2c-16.7,0-28.5-10-31.5-23.4h69C378.7,83.7,362.2,55.1,330.5,55.1z M330.5,69.6
            c16.3,0,26.2,11.5,26.7,23.4h-56.6C303.5,80,314.6,69.6,330.5,69.6z"
        />
        <polygon
          points="287.6,65.1 287.6,62.8 287.6,56.7 240.7,56.7 240.7,62.8 240.7,65.1 240.7,71.2 255.6,71.2 232.3,124.6 
            209,71.2 223.9,71.2 223.9,65.1 223.9,62.8 223.9,56.7 177,56.7 177,62.8 177,65.1 177,71.2 193.2,71.2 225.6,145.4 232.3,145.4 
            238.9,145.4 271.4,71.2 287.6,71.2 			"
        />
        <polygon
          points="168.4,56.7 136.9,56.7 136.9,62.8 136.9,65.1 136.9,71.2 153.9,71.2 153.9,129.4 136.9,129.4 136.9,135.6 
            136.9,137.8 136.9,144 185.4,144 185.4,137.8 185.4,135.6 185.4,129.4 168.4,129.4 			"
        />
        <path
          d="M159.4,42.1c6.8,0,12.3-5.5,12.3-12.3c0-6.6-5.5-12.1-12.3-12.1c-6.6,0-12.1,5.5-12.1,12.1
            C147.3,36.6,152.8,42.1,159.4,42.1z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M107.8,91.8c0-23.9-14.6-30.6-27-30.6c-12.3,0-24.7,7.3-33.5,17.8V20.1H22v2.3h23.1v113.2H22v2.3h48.5v-2.3
            H47.4v-53c8.7-11.5,21-19.1,33.5-19.1c11.8,0,24.7,5.7,24.7,28.3v46.1h25.4v-2.3h-23.1V91.8z"
        />
        <polygon
          class="st0"
          points="162.3,62.8 136.9,62.8 136.9,65.1 160,65.1 160,135.6 136.9,135.6 136.9,137.8 185.4,137.8 
            185.4,135.6 162.3,135.6 			"
        />
        <path
          class="st0"
          d="M159.4,36.1c3.6,0,6.3-2.7,6.3-6.3c0-3.4-2.7-6.1-6.3-6.1c-3.4,0-6.1,2.7-6.1,6.1
            C153.2,33.4,156,36.1,159.4,36.1z M159.4,26c2.3,0,4,1.6,4,3.9c0,2.3-1.6,4-4,4c-2.1,0-3.9-1.6-3.9-4
            C155.5,27.7,157.1,26,159.4,26z"
        />
        <path
          class="st0"
          d="M330.5,61.2c-23.6,0-39.1,18.9-39.1,39.3c0,21.2,16.7,39,40.7,39c11.8,0,23.1-4.4,32.3-12.1l-1.5-1.6
            c-9.1,7.4-19.4,11.5-30.9,11.5c-22.8,0-38-15.8-38.5-35.7h71.5C369.6,82.2,355.9,61.2,330.5,61.2z M363.1,99.2h-69.5
            c0.6-18.9,14.7-35.7,36.9-35.7C353.3,63.5,366.2,81.9,363.1,99.2z"
        />
        <polygon
          class="st0"
          points="240.7,65.1 264.9,65.1 232.3,140.4 199.6,65.1 223.9,65.1 223.9,62.8 177,62.8 177,65.1 197.2,65.1 
            232.3,145.4 267.4,65.1 287.6,65.1 287.6,62.8 240.7,62.8 			"
        />
      </g>
    </g>
    <g>
      <path
        d="M108.2,176.1c3,0,4.5,1.3,4.5,3.7v1.5c0,2.3-1.5,3.6-4.5,3.6h-3.4v5.1h-2.8v-13.9H108.2z M104.8,182.6h3.1
          c1.4,0,2-0.5,2-1.7v-0.8c0-1.2-0.6-1.7-2-1.7h-3.1V182.6z"
      />
      <path
        d="M129.1,176.1c3,0,4.5,1.2,4.5,3.5v1.4c0,1.7-0.8,2.8-2.6,3.2l3.1,5.8H131l-2.6-5.4h-2.6v5.4H123v-13.9H129.1z
          M125.8,182.3h3.1c1.4,0,2-0.5,2-1.6V180c0-1.2-0.6-1.7-2-1.7h-3.1V182.3z"
      />
      <path
        d="M150.9,175.9c3.4,0,4.9,1.7,4.9,5.1v4.3c0,3.4-1.7,4.8-4.9,4.8H149c-3.3,0-5-1.4-5-4.8V181c0-3.3,1.5-5.1,5-5.1H150.9z
          M149.3,178.2c-1.7,0-2.5,0.8-2.5,2.9v4.2c0,2,0.8,2.7,2.5,2.7h1.3c1.7,0,2.5-0.7,2.5-2.7V181c0-2-0.7-2.9-2.5-2.9H149.3z"
      />
      <path
        d="M172.5,176.1c3,0,4.5,1.3,4.5,3.7v1.5c0,2.3-1.5,3.6-4.5,3.6h-3.4v5.1h-2.8v-13.9H172.5z M169.1,182.6h3.1
          c1.4,0,2-0.5,2-1.7v-0.8c0-1.2-0.6-1.7-2-1.7h-3.1V182.6z"
      />
      <path
        d="M190,178.4v3.4h6.4v2.2H190v3.8h6.9v2.2h-9.7v-13.9h9.5v2.2H190z"
      />
      <path
        d="M213.2,176.1c3,0,4.5,1.2,4.5,3.5v1.4c0,1.7-0.8,2.8-2.6,3.2l3.1,5.8h-3.1l-2.6-5.4h-2.6v5.4h-2.8v-13.9H213.2z
          M209.9,182.3h3.1c1.4,0,2-0.5,2-1.6V180c0-1.2-0.6-1.7-2-1.7h-3.1V182.3z"
      />
      <path d="M234.2,178.4V190h-2.8v-11.6h-4.1v-2.2h11v2.2H234.2z" />
      <path d="M248.3,190v-13.9h2.8V190H248.3z" />
      <path
        d="M264.5,178.4v3.4h6.4v2.2h-6.4v3.8h6.9v2.2h-9.7v-13.9h9.5v2.2H264.5z"
      />
      <path
        d="M281.1,179.4c0-2.1,1-3.5,5.2-3.5c4.2,0,5.2,1.2,5.2,3.4l-2.7,0.2c0-0.9-0.4-1.4-2.5-1.4c-2,0-2.4,0.5-2.4,1.4v0.7
          c0,0.9,0.6,1.1,2.9,1.3c3,0.2,5.3,0.7,5.3,3.8v1.5c0,2.4-1.7,3.4-5.7,3.4c-3.8,0-5.4-0.8-5.4-3.6l2.6-0.1c0,1,0.6,1.5,2.8,1.5
          c2.2,0,2.9-0.6,2.9-1.4v-0.7c0-1.3-0.8-1.4-3.1-1.6c-3.2-0.3-5-0.8-5-3.2V179.4z"
      />
    </g>
    <g>
      <path
        d="M387.7,60.2c0,4.1-3.4,7.5-7.5,7.5c-4.1,0-7.5-3.4-7.5-7.5c0-4.1,3.4-7.5,7.5-7.5C384.3,52.7,387.7,56.1,387.7,60.2z
          M374.4,60.2c0,3.3,2.6,5.9,5.8,5.9c3.1,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9C377,54.3,374.4,56.9,374.4,60.2z M380.6,56.4
          c1.6,0,2.4,0.7,2.4,1.9v0.7c0,0.9-0.4,1.5-1.4,1.7l1.7,3.1h-1.8l-1.4-2.9h-1.3v2.9h-1.6v-7.5H380.6z M380.5,59.7
          c0.7,0,1-0.2,1-0.8v-0.4c0-0.6-0.2-0.8-1-0.8h-1.6v2H380.5z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "logoSVG"
};
</script>

<style scoped>
.st0 {
  fill: #8d7535;
}</style
>>
